import React, { useEffect, useState } from "react";
import { Icons } from "@texada/ui";
import fleetlogicAPI from "helpers/fleetlogicAPI";

interface InAppMessage {
  id: number;
  title: string;
  content: string;
  message_type: "warning" | "error" | "success" | "info";
}

const InAppMessages: React.FC = () => {
  const [messages, setMessages] = useState<InAppMessage[]>([]);

  useEffect(() => {
    fleetlogicAPI
      .get("/rest-api/in-app-messages")
      .then(res => setMessages(res.data))
      .catch(err => {
        console.debug(err);
      });
  }, []);

  if (messages.length === 0) return null;

  const getIcon = (type: string) => {
    switch (type) {
      case "warning":
        return <Icons.Warning />;
      case "error":
        return <Icons.Close />;
      case "success":
        return <Icons.Check />;
      default:
        return <Icons.Info />;
    }
  };

  return (
    <div className="in-app-messages">
      {messages.map(msg => (
        <div key={msg.id}>
          <span className={`in-app-message-icon ${msg.message_type}`}>
            {getIcon(msg.message_type)}
            <p dangerouslySetInnerHTML={{ __html: msg.content }} />
          </span>
        </div>
      ))}
    </div>
  );
};

export default InAppMessages;
